export const qualityOptions = [
  { value: 2, label: "Volle Qualität" },
  { value: 1, label: "50% Qualität" },
  { value: 0, label: "Ohne Qualität" },
];
